import { SxProps, Theme } from '@mui/system';

const styles: Record<string, SxProps<Theme>> = {
  autocomplete: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      bgcolor: 'var(--surface-base)',
      borderRadius: 'var(--radius-none)',
      border: 'var(--elevation-1)',
      boxShadow: 'none',
      '& fieldset': {
        border: 'none',
      },
      '&:hover': {
        borderColor: 'var(--border-default)',
        transform: 'none',
      },
      '&.Mui-focused': {
        outline: 'var(--focus-ring)',
        outlineOffset: 0,
        borderColor: 'transparent',
        '& fieldset': {
          border: 'none',
        },
      },
      transition: 'all var(--duration-base) var(--easing)',
    },
    '& .MuiInputBase-input': {
      fontSize: 'var(--text-sm)',
      fontFamily: 'var(--font-data)',
      color: 'var(--text-primary)',
      '&::placeholder': {
        color: 'var(--text-placeholder)',
        opacity: 1,
      },
    },
    '& .MuiInputLabel-root': {
      fontSize: 'var(--text-sm)',
      fontFamily: 'var(--font-data)',
      color: 'var(--text-secondary)',
      '&.Mui-focused': {
        color: 'var(--text-primary)',
      },
    },
    // Style the dropdown paper
    '& + .MuiAutocomplete-popper': {
      '& .MuiPaper-root': {
        backgroundColor: 'var(--surface-base)',
        borderRadius: 'var(--radius-none)',
        boxShadow: 'none',
        border: 'var(--elevation-2)',
        marginTop: '1px',
      },
      '& .MuiAutocomplete-option': {
        fontSize: 'var(--text-sm)',
        fontFamily: 'var(--font-data)',
        color: 'var(--text-primary)',
        backgroundColor: 'var(--surface-base)',
        '&:hover': {
          backgroundColor: 'var(--surface-raised)',
          color: 'var(--text-primary)',
        },
        '&[aria-selected="true"]': {
          backgroundColor: 'var(--surface-overlay)',
          color: 'var(--text-primary)',
        },
      },
    },
  },
};

export default styles;
